import CONSTANTS from '../../util/constants';

const initState = {
    isLoading: false,
    getMoveData: [],
    editMoveData: [],
    createMoveData: [],
    getContainerData: [],
    getDoorForMoveData: [],
    getSpaceFromData: [],
    getSpaceToData: [],
    createContainerData: {}
}

const MoveReducer = (state = initState, { type, payload }) => {

    switch (type) {

        case CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_MOVES_API_SUCCESS:
            return {
                ...state,
                getMoveData: payload.value
            }

        case CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.ADD_MOVES_API_SUCCESS:
            return {
                ...state,
                createMoveData: payload.value
            }

        case CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_CONTAINERS_API_SUCCESS:
            return {
                ...state,
                getContainerData: payload.value
            }
        case CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_DOOR_FOR_MOVES_API_SUCCESS:
            return {
                ...state,
                getDoorForMoveData: payload.value
            }
        case CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_SPACE_FROM_API_SUCCESS:
            return {
                ...state,
                getSpaceFromData: payload.value
            }
        case CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_SPACE_TO_API_SUCCESS:
            return {
                ...state,
                getSpaceToData: payload.value
            }
        case CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.CREATE_CONTAINER_API_SUCCESS:
            return {
                ...state,
                createContainerData: payload.value
            }
        default:
            return state

    }
}

export default MoveReducer;
